import { pipe, subscribe } from 'agos';

export default function() {
  const ccLandingBodyContainers = document.querySelectorAll('.cc-detail-body');
  ccLandingBodyContainers.forEach(container => {
    const timer = container.querySelector('.countdown-clock');
    if (! timer) {
      return;
    }
    const accessLink = container.querySelector('.cc-detail-body__links__access__text');
    const ctaLink = container.querySelector('.cc-detail-body__links__cta');

    // TO DO: Unsub
    pipe(
      timer.countdown$,
      subscribe({
        next: data => {
          const timerData = Object.keys(data).map(key => data[ key ]);
          const isDone = timerData.every(t => t === '00');
          if (isDone) {
            accessLink && (accessLink.innerText = accessLink.dataset.postText);
            ctaLink && (ctaLink.style.display = 'block');
          }
        },
      })
    );
  });
}
